import { Html5Qrcode } from 'html5-qrcode';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const qrConfig = {
  fps: 10,
  qrbox: 350,
  aspectRatio: 1,
  rememberLastUsedCamera: true,
};

let html5QrCode: Html5Qrcode;

export default function CameraScanner() {
  const navigate = useNavigate();
  const handleStop = () => {
    try {
      html5QrCode.stop().then(() => {
        html5QrCode.clear();
      });
    } catch (_) {
      // do nothing
    }
  };
  const qrCodeSuccessCallback = (value: string) => {
    handleStop();
    const trimValue = value.replace(/\s+/g, '');
    navigate(`/gift-card/information/${trimValue}`);
  };
  const qrCodeErrorCallback = () => {};

  const handleClickAdvanced = () => {
    html5QrCode.start(
      { facingMode: 'environment' },
      qrConfig,
      qrCodeSuccessCallback,
      qrCodeErrorCallback,
    );
  };

  useEffect(() => {
    html5QrCode = new Html5Qrcode('reader');
    const oldRegion = document.getElementById('qr-shaded-region');
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    oldRegion && oldRegion.remove();
    setTimeout(() => {
      handleClickAdvanced();
    }, 500);
    return () => {
      handleStop();
    };
  }, []);

  return (
    <div
      id="reader"
      className="relative size-[400px] overflow-hidden rounded-md border bg-silver"
    ></div>
  );
}
